import React, { Fragment, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { CurrenciesInitialsForUpdate } from "../currencies/interfaces/CurrenciesClass";
import { getAccountBaseCurrencyIdAsync, getvueAccountCurrencyByAccountIdAndDisabledAsync, UpdateAccountBaseCurrencyAsync } from "../currencies/CurrenciesSlice";
import Select, { StylesConfig } from 'react-select';
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import fetchAPI from "../../../common/fetchAPI";
import { dropDownSelectionStyles, getValueFromResource } from "../../../common/timeLiveFunction";
export const BaseCurrencyForm = (props: any) => {
    const { t, onToggleModal,BaseCurrencyArray,selectedOptionDropDown } = props;
    const { AccountBaseCurrencyId, BaseCurrencyList, isLoading, isReload } = useAppSelector((state) => state.currencies);
    const [currentFieldsData, SetcurrentFieldsData] = useState<any>(CurrenciesInitialsForUpdate);
    const dispatch = useAppDispatch();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const { maxMenuHeight } = useAppSelector(state => state.globalState);

    const handleSubmit = (values: any) => {

        if (values.AccountCurrencyId > 0) {
            dispatch(UpdateAccountBaseCurrencyAsync({ AccountCurrencyId: values.AccountCurrencyId, IsUpdateExistingRecords: values.IsUpdateExistingRecords }))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast('Base Currency Updated Successfully', 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

                }).catch((rejectedValueOrSerializedError) => {

                })

        }
        onToggleModal();
    }

    return (
        <>
            <Formik
                initialValues={{
                    ...currentFieldsData,
                    AccountCurrencyId: selectedOptionDropDown?.value || "",
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    AccountCurrencyId: yup
                        .string()
                        .required(t('Currency is required'))
                })}>
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className="modal drawer-overlay" style={{ display: 'block' }}>
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                        <h5 className="modal-title mainHeading">{getValueFromResource('Base Currency',dispatch,t)}  </h5>
                                        <div
                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                            onClick={onToggleModal}
                                        >
                                            <KTSVG
                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                className="svg-icon svg-icon-1x"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-body">
                                        <div className="mb-3">
                                            <label className="fs-7 fw-normal mb-2">{getValueFromResource('Name',dispatch,t)}</label>
                                            <Select
                                                value={BaseCurrencyArray.find((option: any) => option.value == values.AccountCurrencyId)}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={BaseCurrencyArray}
                                                name="AccountCurrencyId"
                                                id="AccountCurrencyId"
                                                onBlur={() => setFieldTouched('AccountCurrencyId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "AccountCurrencyId",
                                                            value: selectedOption?.value
                                                        },
                                                    });
                                                }}
                                                 styles={dropDownSelectionStyles}
                                                 maxMenuHeight={maxMenuHeight}
                                            />
                                            <div>
                                                {touched.AccountCurrencyId   && errors.AccountCurrencyId &&
                                                    <p className='errorMsg'>{errors.AccountCurrencyId as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{getValueFromResource('Update existing records',dispatch,t)}</label>
                                            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                <input type="checkbox"
                                                    className="form-check-input h-20px w-30px"
                                                    id="IsUpdateExistingRecords"
                                                    name="IsUpdateExistingRecords"
                                                    onChange={handleChange('IsUpdateExistingRecords')}
                                                    checked={values.IsUpdateExistingRecords}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }}>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                            onClick={onToggleModal}
                                        >
                                            {getValueFromResource('Cancel',dispatch,t)}
                                        </button>
                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                            onClick={() => handleSubmit()} disabled={!isValid}
                                        >
                                            {getValueFromResource('Save',dispatch,t)}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )

}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}


